module.exports = __webpack_public_path__ + "img/operationCapacity1.c63c15ce.png";